import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  return (
    <div className={`sidebar ${isOpen ? 'show' : ''}`}>
      <div className="sidebar-content">
        <div className="sidebar-header">
          <h5 className="sidebar-title" style={{ color: 'white', fontWeight: 'bold' }}>
            <button 
              className="btn-close d-block d-md-none me-2"
              onClick={onClose}
              aria-label="Close"
            ></button>
            HHA Dashboard
          </h5>
        </div>
        
        <ul className="sidebar-nav">
          <li className="sidebar-nav-item">
            <Link to="/dashboard" className={`sidebar-nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}>
              <i className="fa-solid fa-home me-2"></i>Dashboard
            </Link>
          </li>
          
          {/* <li className="sidebar-nav-item">
            <Link to="/reports" className={`sidebar-nav-link ${location.pathname === '/reports' ? 'active' : ''}`}>
              <i className="fa-solid fa-chart-bar me-2"></i>Reports
            </Link>
          </li>
          
          <li className="sidebar-nav-item">
            <Link to="/revenue" className={`sidebar-nav-link ${location.pathname === '/revenue' ? 'active' : ''}`}>
              <i className="fa-solid fa-dollar-sign me-2"></i>Revenue
            </Link>
          </li>
          
          <li className="sidebar-nav-item">
            <Link to="/analytics" className={`sidebar-nav-link ${location.pathname === '/analytics' ? 'active' : ''}`}>
              <i className="fa-solid fa-chart-line me-2"></i>Analytics
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar; 